import axios from 'axios'
import { httpInstance } from '../../api'
import * as types from '../mutation-types'

const state = {
  approvalProfiles: [],
  activeApprovalProfile: {},
  approvalLimits: [],
  approvalUsers: [],
  userDevices: [],
  activeApprovalUser: {},
  workflow: [],
  activeWorkflow: {}
}

const getters = {
  getApprovalProfiles: state => state.approvalProfiles,
  getActiveApprovalProfile: state => state.activeApprovalProfile,
  getApprovalLimits: state => state.approvalLimits,
  getNextMinLimit: state => {
    if (state.approvalLimits.length > 0) {
      return (
        state.approvalLimits[state.approvalLimits.length - 1].total_value_to ||
        0
      )
    }
    return 0
  },
  getApprovalUsers: state => state.approvalUsers,
  getActiveApprovalUser: state => state.activeApprovalUser,
  getWorkflow: state => state.workflow,
  getActiveWorkflow: state => state.activeWorkflow,
  getUserDevices: state => state.userDevices,
  getUserNotNullDevices: state => {
    let notNullDevices = []
    state.userDevices.forEach(d => {
      if (d.device_name != null) {
        notNullDevices.push(d)
      }
    })
    return notNullDevices
  }
}

const mutations = {
  [types.GET_APPROVAL_PROFILES] (state, payload) {
    state.approvalProfiles = payload
  },

  [types.SET_ACTIVE_APPROVAL_PROFILE] (state, payload) {
    state.activeApprovalProfile = payload
  },

  [types.ADD_APPROVAL_PROFILE] (state, payload) {
    state.approvalProfiles.push(payload)
  },

  [types.CHANGE_APPROVAL_PROFILE] (state, payload) {
    let atIndex = state.approvalProfiles.findIndex(d => d.id === payload.id)
    state.approvalProfiles.splice(atIndex, 1)
    state.approvalProfiles.splice(atIndex, 0, payload)
  },

  [types.DELETE_APPROVAL_PROFILE] (state, id) {
    let atIndex = state.approvalProfiles.findIndex(d => d.id === id)
    state.approvalProfiles.splice(atIndex, 1)
  },

  [types.GET_APPROVAL_LIMITS] (state, payload) {
    state.approvalLimits = payload
  },

  [types.DELETE_APPROVAL_LIMIT] (state, id) {
    let atIndex = state.approvalLimits.findIndex(d => d.id === id)
    state.approvalLimits.splice(atIndex, 1)
  },

  [types.ADD_APPROVAL_LIMIT] (state, payload) {
    state.approvalLimits.push(payload)
  },

  [types.CHANGE_APPROVAL_LIMIT] (state, payload) {
    let atIndex = state.approvalLimits.findIndex(d => d.id === payload.id)
    state.approvalLimits.splice(atIndex, 1)
    state.approvalLimits.splice(atIndex, 0, payload)
  },

  [types.GET_APPROVAL_USERS] (state, payload) {
    state.approvalUsers = payload
  },

  [types.ADD_APPROVAL_USER] (state, payload) {
    state.approvalUsers.push(payload)
  },

  [types.SET_ACTIVE_APPROVAL_USER] (state, payload) {
    state.activeApprovalUser = payload
  },

  [types.CHANGE_APPROVAL_USER] (state, payload) {
    let atIndex = state.approvalUsers.findIndex(u => u.id === payload.id)
    state.approvalUsers.splice(atIndex, 1)
    state.approvalUsers.splice(atIndex, 0, payload)
  },

  [types.DELETE_APPROVAL_USER] (state, id) {
    let atIndex = state.approvalUsers.findIndex(u => u.id === id)
    state.approvalUsers.splice(atIndex, 1)
  },

  [types.BLOCK_APPROVAL_USER] (state, payload) {
    let atIndex = state.approvalUsers.findIndex(u => u.id === payload.id)
    state.approvalUsers[atIndex].is_blocked = payload.is_blocked
  },

  [types.GET_USER_DEVICES] (state, payload) {
    state.userDevices = payload
  },

  [types.BLOCK_USER_DEVICE] (state, payload) {
    let atIndex = state.userDevices.findIndex(d => d.id === payload.id)
    state.userDevices[atIndex].is_blocked = payload.is_blocked
  },

  [types.GET_WORKFLOW] (state, payload) {
    state.workflow = payload
  },

  [types.SET_ACTIVE_WORKFLOW] (state, payload) {
    state.activeWorkflow = payload
  },

  [types.ADD_WORKFLOW] (state, payload) {
    state.workflow.push(payload)
  },

  [types.CHANGE_WORKFLOW] (state, payload) {
    let atIndex = state.workflow.findIndex(d => d.id === payload.id)
    state.workflow.splice(atIndex, 1)
    state.workflow.splice(atIndex, 0, payload)
  },

  [types.DELETE_WORKFLOW] (state, id) {
    let atIndex = state.workflow.findIndex(d => d.id === id)
    state.workflow.splice(atIndex, 1)
  }
}

const actions = {
  async fetchAllApprovalProfiles ({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('approval-profile/list-unlimited')
      .then(response => {
        commit(types.GET_APPROVAL_PROFILES, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async setActiveApprovalProfile ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`approval-profile/${id}/get`)
      .then(response => {
        commit(types.SET_ACTIVE_APPROVAL_PROFILE, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchActiveApprovalProfile ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await axios
      .all([
        httpInstance.get(`approval-profile/${id}/get`),
        httpInstance.get(`approval-limit/approval-profile/${id}/list`)
      ])
      .then(
        axios.spread((activeProfile, limits) => {
          limits.data.sort((a, b) => {
            return a.total_value_to - b.total_value_to
          })
          commit(types.SET_ACTIVE_APPROVAL_PROFILE, activeProfile.data)
          commit(types.GET_APPROVAL_LIMITS, limits.data)
          commit(types.SET_LOADING, false)
        })
      )
  },

  async addApprovalProfile ({ commit, dispatch }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('approval-profile/add', {
        description: payload.description,
        company_code: payload.company_code,
        type: payload.type
      })
      .then(response => {
        dispatch('fetchAllApprovalProfiles')
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changeApprovalProfile ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`approval-profile/${payload.id}/update`, {
        description: payload.description,
        company_code: payload.company_code,
        type: payload.type
      })
      .then(response => {
        commit(types.CHANGE_APPROVAL_PROFILE, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async deleteApprovalProfile ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`approval-profile/${id}/delete`)
      .then(response => {
        commit(types.DELETE_APPROVAL_PROFILE, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchApprovalLimits ({ commit }, id) {
    await httpInstance
      .get(`approval-limit/approval-profile/${id}/list`)
      .then(response => {
        commit(types.GET_APPROVAL_LIMITS, response.data)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async deleteApprovalLimit ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`approval-limit/${id}/delete`)
      .then(response => {
        commit(types.DELETE_APPROVAL_LIMIT, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async addApprovalLimit ({ commit, dispatch }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('approval-limit/add', {
        approval_profile_id: payload.approval_profile_id,
        max_value_from: payload.total_value_from,
        max_value_to: payload.total_value_to,
        is_unlimited: payload.is_unlimited
      })
      .then(response => {
        dispatch('fetchApprovalLimits', payload.approval_profile_id)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changeApprovalLimit ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`approval-limit/1/update`, {
        approval_profile_id: payload.approval_profile_id,
        max_value_from: payload.total_value_from,
        max_value_to: payload.total_value_to,
        is_unlimited: payload.is_unlimited
      })
      .then(response => {
        commit(types.CHANGE_APPROVAL_LIMIT, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchApprovalUsers ({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('user/list-unlimited')
      .then(response => {
        commit(types.GET_APPROVAL_USERS, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async addApprovalUser ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('user/create', payload)
      .then(response => {
        console.log(response)
        commit(types.LOAD_RESPONSE, response)
        commit(types.ADD_APPROVAL_USER, payload)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async setActiveApprovalUser ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`user/${id}/one`)
      .then(response => {
        commit(types.SET_ACTIVE_APPROVAL_USER, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changeApprovalUser ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`user/${payload.id}/update`, {
        company_code: payload.company_code,
        rank_id: payload.rank_id,
        employee_id: payload.employee_id,
        email: payload.email,
        salutation: payload.salutation,
        first_name: payload.first_name,
        last_name: payload.last_name
      })
      .then(response => {
        commit(types.CHANGE_APPROVAL_USER, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async changeApprovalPassword ({commit}, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/auth/mibile-user/${payload.id}/change-password`, payload.user)
      .then(response => {
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async deleteApprovalUser ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`user/${id}/delete`)
      .then(response => {
        commit(types.DELETE_APPROVAL_USER, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async blockApprovalUser ({ commit }, payload) {
    await httpInstance
      .get(`auth/user/${payload.id}/block`)
      .then(response => {
        commit(types.BLOCK_APPROVAL_USER, payload)
        commit(types.LOAD_RESPONSE, response)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },

  async fetchBlockedDevices ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`user/user-device/list`)
      .then(response => {
        commit(types.GET_USER_DEVICES, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchUserDevices ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`user/user-device/${id}/list`)
      .then(response => {
        commit(types.GET_USER_DEVICES, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async blockUserDevice ({ commit }, payload) {
    await httpInstance
      .get(`auth/user-token/${payload.id}/block`)
      .then(response => {
        commit(types.BLOCK_USER_DEVICE, payload)
        commit(types.LOAD_RESPONSE, response)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },

  async fetchWorkflow ({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('approval-workflow-setting/list-unlimited')
      .then(response => {
        commit(types.GET_WORKFLOW, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async searchWorkflow ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(
        `approval-workflow-setting/list?companyId=${
          payload.companyId
        }&divisionId=${payload.divisionId}&plantId=${
          payload.plantId
        }&departmentId=${payload.departmentId}&approvalProfileId=${
          payload.approvalProfileId
        }`
      )
      .then(response => {
        console.log(response)
        commit(types.GET_WORKFLOW, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async setActiveWorkflow ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`approval-workflow-setting/${id}/one`)
      .then(response => {
        console.log(response)
        commit(types.SET_ACTIVE_WORKFLOW, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async addWorkflow ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('approval-workflow-setting/create', payload)
      .then(response => {
        commit(types.ADD_WORKFLOW, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.LOAD_RESPONSE, error.response)
        console.log(error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changeWorkflow ({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`approval-workflow-setting/${payload.id}/update`, {
        company_id: payload.company_id,
        plant_id: payload.plant_id,
        division_id: payload.division_id,
        department_id: payload.department_id,
        approval_limit_id: payload.approval_limit_id,
        employee_id_level_1: payload.approval_level_1,
        employee_id_level_2: payload.approval_level_2,
        employee_id_level_3: payload.approval_level_3,
        employee_id_level_4: payload.approval_level_4,
        employee_id_level_5: payload.approval_level_5,
        employee_id_level_6: payload.approval_level_6,
        employee_id_level_7: payload.approval_level_7,
        employee_id_level_8: payload.approval_level_8,
        requisitioner: payload.requisitioner
      })
      .then(response => {
        commit(types.CHANGE_WORKFLOW, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async deleteWorkflow ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`approval-workflow-setting/${id}/delete`)
      .then(response => {
        commit(types.DELETE_WORKFLOW, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/workflow.js